// The error `AuthContext.signUp` throws when `POST /v1/auth/signup` answers
// with a non-2xx status (#2077).
//
// It keeps the HTTP status, which a plain `Error` dropped, so the sign-up page
// can tell the generic 403 refusal from every other failure. It has no `code`
// property, deliberately: `getErrorMessage` treats an error carrying one as a
// Firebase error and would replace the message.

export class SignUpRequestError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'SignUpRequestError';
    this.status = status;
  }
}

// The error `AuthContext.signUp` throws when the API created the account but
// the sign-in that follows failed twice (#2123).
//
// The account exists, so showing this on the sign-up form is wrong: submitting
// again is refused with the generic 403, and "reset your password" is the wrong
// advice for someone who set it a few seconds ago. The sign-up page sends them
// to sign in instead.
//
// It carries no email address, deliberately: `signUp` and `useSignUp` both
// pass what they catch to `console.error`. The page that needs the address
// already has it, from the form. No `code` property either, for the reason
// given above.
export class AccountCreatedSignInFailedError extends Error {
  constructor() {
    super('Your account was created, but we could not sign you in.');
    this.name = 'AccountCreatedSignInFailedError';
  }
}
